import { Component, Input, TemplateRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-hero-header',
    templateUrl: './hero-header.shared.component.html',
    styleUrls: ['./hero-header.shared.component.scss']
})
export class HeroHeaderComponent {
    @Input() public preTitle!: string;
    @Input() public postTitle!: TemplateRef<any>;

    @Input() public loading: boolean = false;

    @Input() public preHeaderType: OLO.Components.HEADER_TYPE = '5';
    @Input() public preHeaderLeft!: TemplateRef<any>;
    @Input() public preHeaderRight!: TemplateRef<any>;
    @Input() public preHeaderInverted: boolean = false;
    @Input() public preHeaderMarginTop: OLO.Components.MARGIN_SIZE = 'xs';
    @Input() public preHeaderMarginBottom: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public preHeaderPaddingTop: OLO.Components.MARGIN_SIZE = null;
    @Input() public preHeaderPaddingBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public preHeaderBrandAccent: boolean = true;
    @Input() public preHeaderCounter: number = null;
    @Input() public preHeaderPostContent: string | number;
    @Input() public preHeaderPreContent: string | number;
    @Input() public preHeaderEllipsis: boolean = false;
    @Input() public preHeaderCenter: boolean = false;
    @Input() public preHeaderLineHeight: boolean | string;


    @Input() public type: OLO.Components.HEADER_TYPE = '1';
    @Input() public inverted: boolean = true;
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = 'xs';
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = 'xs';
    @Input() public paddingTop: OLO.Components.MARGIN_SIZE = null;
    @Input() public paddingBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public brandAccent: boolean = false;
    @Input() public counter: number = null;
    @Input() public postContent: string | number;
    @Input() public preContent: string | number;
    @Input() public ellipsis: boolean = false;
    @Input() public center: boolean = false;
    @Input() public lineHeight: boolean | string;
    @Input() public left: TemplateRef<any>;
    @Input() public right: TemplateRef<any>;
}
